import React, { useState, useEffect } from "react";
import { Box, Typography, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Drawer from "@mui/material/Drawer";
import { post, api, put } from "../../utils/api";
import InputField from "../../Components/Masters/InputField";
import SelectField from "../../Components/Masters/SelectField";
import FileField from "../../Components/Masters/FileField";
import Multiline from "../../Components/Masters/Multiline";
import formatTitleWithOptional from "../Scope1/OptionalFeild";
import InputDate from "../../Components/Masters/InputDate";
import CustomDateInput from "./CustomDateInput";
import dayjs from "dayjs";
import EditDialog from "../../Components/Common/EditDialog";

function AddData({
  inputData,
  fetchData,
  isDrawerOpen,
  setIsDrawerOpen,
  setsnackOpen,
  editData,
  isEditMode,
  setIsEditMode,
  user,
  activeTab,
}) {
  const [errors, setErrors] = useState({});
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadProgress, setUploadProgress] = useState({});
  const [raisedAgainst, setRaisedAgainst] = useState("");
  const [editDialog, setEditDialog] = useState(false);
  const [initialFormState, setInitialFormState] = useState({});
  const [exitAction, setExitAction] = useState(null);
  // Initialize form data based on mode
  const initialState = {
    type: user?.companyAdmin ? "" : "Facility", // Default for non-admins
    dataType: activeTab === 0 ? "Production" : "Revenue",
    periodType: activeTab === 0 ? "Monthly" : "Annual",
    date: "",
    production: {
      quantity: "",
      unit: "",
    },
    revenue: {
      value: "",
      currency: "",
    },
    remarks: "",
  };

  const [formData, setFormData] = useState(initialState);

  useEffect(() => {
    if (isDrawerOpen) {
      const initialState = isEditMode && editData 
        ? { ...editData } 
        : { ...formData };
      setInitialFormState(initialState);
    }
  }, [isDrawerOpen, isEditMode, editData]);

  

  // Reset form when switching between add and edit modes
  useEffect(() => {
    console.log(editData,"editData")
    if (isEditMode && editData) {
      setFormData({
        type: editData.type || (user?.companyAdmin ? "" : "Facility"),
        dataType:
          editData.dataType || (activeTab === 0 ? "Production" : "Revenue"),
        periodType:
          editData.periodType || (activeTab === 0 ? "Monthly" : "Annual"),
        facilityName: editData.facilityName?._id || "",
        date: editData.date || "",
        production: {
          quantity: editData?.production?.quantity || "",
          unit: editData?.production?.unit || "",
        },
        revenue: {
          value: editData?.revenue?.value || "",
          currency: editData?.revenue?.currency || "",
        },
        remarks: editData.remarks || "",
      });
    } else {
      setFormData({
        ...initialState,
        dataType: activeTab === 0 ? "Production" : "Revenue",
        periodType: activeTab === 0 ? "Monthly" : "Annual",
      });
      setUploadedFiles([]);
    }
  }, [isEditMode, editData, isDrawerOpen, activeTab]);

  useEffect(() => {
    console.log("Edit Data in RaisedTicket:", editData);
    console.log("Is Edit Mode:", isEditMode);
  }, [editData, isEditMode]);

  // useEffect(() => {
  //   if (formData.dataType === "Production") {
  //     setFormData((prev) => ({ ...prev, periodType: "Monthly" }));
  //   } else if (formData.dataType === "Revenue") {
  //     setFormData((prev) => ({ ...prev, periodType: "Annual" }));
  //   }
  // }, [formData.dataType]);

  useEffect(() => {
    if (formData.dataType === "Production") {
      setFormData((prev) => ({
        ...prev,
        periodType: "Monthly",
        date: "",
      }));
    } else if (formData.dataType === "Revenue") {
      setFormData((prev) => ({
        ...prev,
        periodType: "Annual",
        date: "",
      }));
    }
  }, [formData.dataType]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Reset facility when type changes to Consolidated
    if (name === "type" && value === "Consolidated") {
      setFormData((prev) => ({
        ...prev,
        facilityName: "",
      }));
    }

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };

      if (name.includes(".")) {
        const [parentKey, childKey] = name.split(".");
        if (newErrors[parentKey]?.[childKey]) {
          delete newErrors[parentKey][childKey];
          if (Object.keys(newErrors[parentKey]).length === 0) {
            delete newErrors[parentKey];
          }
        }
      } else {
        delete newErrors[name];
      }

      return newErrors;
    });

    // Handle numeric fields (production quantity and revenue value)
    if (name === "production.quantity" || name === "revenue.value") {
      // Allow only numbers and decimal point
      if (value && !/^(\d+\.?\d*|\.\d+)$/.test(value)) {
        return; // Skip update if not a valid number
      }
    }

    // Handle nested keys like "production.quantity" or "revenue.value"
    if (name.includes(".")) {
      const [parentKey, childKey] = name.split(".");
      setFormData((prev) => ({
        ...prev,
        [parentKey]: {
          ...prev[parentKey],
          [childKey]: value,
        },
      }));
    } else {
      // Regular top-level key update
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const hasChanges = () => {
    return JSON.stringify(formData) !== JSON.stringify(initialFormState);
  };

  // Handle close request
  const handleCloseRequest = () => {
    if (hasChanges()) {
      setEditDialog(true);
    } else {
      handleClose();
    }
  };

  // Handle exit confirmation
  const handleExitAgree = (action) => {
    if (action === 'discard') {
      handleClose();
    }
    setEditDialog(false);
  };

  const handleClose = () => {
    setIsDrawerOpen(false);
    setIsEditMode(false);
    setErrors({});
    setUploadedFiles([]);
    setFormData(initialFormState); // Reset to initial state
  };

  // const handleClose = () => {
  //   setIsDrawerOpen(false);
  //   setIsEditMode(false);
  //   setErrors({});
  //   setUploadedFiles([]);
  // };

  const validateForm = () => {
    const newErrors = {};
    console.log(
      "formData1",
      formData.dataType === "Production" &&
        formData.type !== "Facility" &&
        !formData.facilityName === ""
    );
    // Validate facility name when type is Facility
    // if (
    //   formData.dataType === "Production" &&
    //   formData.type !== "Facility" &&
    //   !formData.facilityName === ""
    // ) {
    //   newErrors.facilityName = "Facility Name is required";
    // }

    // Validate mandatory fields based on dataType
    if (!formData.dataType) {
      newErrors.dataType = "Data Type is required";
    }

    if (!formData.date) {
      newErrors.date =
        formData.dataType === "Production"
          ? `Please select the Month and Year of production.`
          : "Financial Year is required";
    }

    // Validate production/revenue fields based on dataType
    if (formData.dataType === "Production") {
      if (!formData.production?.quantity) {
        newErrors.production = {
          ...newErrors.production,
          quantity: "Quantity is required",
        };
      } else if (isNaN(formData.production.quantity)) {
        newErrors.production = {
          ...newErrors.production,
          quantity: "Quantity must be a number",
        };
      }

      if (!formData.production?.unit) {
        newErrors.production = {
          ...newErrors.production,
          unit: "Unit is required",
        };
      }
    } else if (formData.dataType === "Revenue") {
      if (!formData.revenue?.value) {
        newErrors.revenue = {
          ...newErrors.revenue,
          value: "Value is required",
        };
      } else if (isNaN(formData.revenue.value)) {
        newErrors.revenue = {
          ...newErrors.revenue,
          value: "Value must be a number",
        };
      }

      if (!formData.revenue?.currency) {
        newErrors.revenue = {
          ...newErrors.revenue,
          currency: "Currency is required",
        };
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  console.log("formdata", formData);

  const handleDateChange = ({ name, value }) => {
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: undefined,
    }));

    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const Save = async () => {
    if (!validateForm()) return;

    // Prepare data to send
    const updatedFormData = { ...formData };

    // Remove facilityName if not needed or empty
    if (
      updatedFormData.dataType !== "Production" ||
      updatedFormData.type !== "Facility" ||
      !updatedFormData.facilityName
    ) {
      delete updatedFormData.facilityName;
    }

    try {
      const apiUrl = isEditMode
        ? `${api}/api/revenue/update?id=${editData._id}`
        : `${api}/api/revenue/add`;

      const method = isEditMode ? put : post;
      const response = await method(apiUrl, updatedFormData);

      setsnackOpen({
        open: true,
        message: response.data.message,
        severity: "success",
      });

      handleClose();
      fetchData();
    } catch (err) {
      console.error("Error saving Data:", err);
      const errorMessage = err.response?.data?.message;

      if (errorMessage?.includes("already exists")) {
        // Set error directly to the 'date' field
        setErrors((prev) => ({
          ...prev,
          date: errorMessage,
        }));
      }
    }
  };

  const renderInputField = (el) => {
    if (el.fieldName === "dataType" || el.fieldName === "periodType") {
      return null;
    }

    if (
      !user?.companyAdmin &&
      (el.fieldName === "dataType" ||
        el.fieldName === "periodType" ||
        el.fieldName === "facilityName")
    ) {
      return null;
    }

    if (
      el.fieldName === "facilityName" &&
      (!user?.companyAdmin || // Not admin? Don't show
        formData.dataType !== "Production" || // Not production? Don't show
        formData.type !== "Facility") // Type not Facility? Don't show
    ) {
      return null;
    }
    const value = formData[el.fieldName] || "";
    switch (el.type) {
      case "select":
        return (
          <SelectField
            title={el.title}
            name={el.fieldName}
            value={value}
            handleChange={(e) => {
              handleChange(e);
            }}
            options={el.option}
            url={el.url}
            errors={errors[el.fieldName]}
            // disable={el.fieldName === "periodType"}
            disable={
              el.fieldName === "periodType" ||
              (!user?.companyAdmin && el.fieldName === "dataType")
            }
            required={el.fieldName === "dataType"}
          />
        );

      case "date":
        const datePlaceholder =
          formData.dataType === "Production" ? "Jan-25" : "FY (e.g., 2023-24)";
        return (
          <Box>
            {/* <InputDate
              title={formatTitleWithOptional(el.title)}
              name={el.fieldName}
              noMaxDate={true}
              value={formData?.[el.fieldName]}
              handleChange={handleDateChange}
              errors={errors[el.fieldName]}
            /> */}

            <CustomDateInput
              title={el.title}
              name={el.fieldName}
              value={formData?.[el.fieldName]}
              handleChange={handleDateChange}
              errors={errors[el.fieldName]}
              dataType={formData.dataType}
              placeholder={datePlaceholder}
              disable={el.disable}
              noMaxDate={el.noMaxDate}
            />
          </Box>
        );

      case "production":
        if (formData.dataType === "Production") {
          return (
            <Box display="flex" gap={1} sx={{ width: "100%", mt: 1 }}>
              <Box sx={{ width: "60%" }}>
                <InputField
                  // title={el.title}
                  title={formatTitleWithOptional(el.title)}
                  handleChange={handleChange}
                  placeholder={el.placeholder}
                  value={formData[el.fieldName]?.quantity || ""}
                  errors={errors[el.fieldName]?.quantity} // Access error for value
                  fieldName={`${el.fieldName}.quantity`}
                />
              </Box>
              <Box sx={{ width: "40%" }}>
                <SelectField
                  title={formatTitleWithOptional("Unit")}
                  name={`${el.fieldName}.unit`}
                  value={formData[el.fieldName]?.unit}
                  handleChange={handleChange}
                  height="41px"
                  options={el.options}
                  errors={errors[el.fieldName]?.unit} // Access error for unit
                  field={`${el.field}.unit`}
                  defaultValue="Unit"
                />
              </Box>
            </Box>
          );
        }
        return null;

      case "revenue":
        if (formData.dataType === "Revenue") {
          return (
            <Box display="flex" gap={1} sx={{ width: "100%", mt: 1 }}>
              <Box sx={{ width: "60%" }}>
                <InputField
                  // title={el.title}
                  title={formatTitleWithOptional(el.title)}
                  handleChange={handleChange}
                  placeholder={el.placeholder}
                  value={formData[el.fieldName]?.value || ""}
                  errors={errors[el.fieldName]?.value}
                  fieldName={`${el.fieldName}.value`}
                />
              </Box>
              <Box sx={{ width: "40%" }}>
                <SelectField
                  title={formatTitleWithOptional("Currency")}
                  name={`${el.fieldName}.currency`}
                  value={formData[el.fieldName]?.currency}
                  handleChange={handleChange}
                  height="41px"
                  options={el.options}
                  errors={errors[el.fieldName]?.currency}
                  field={`${el.field}.currency`}
                  defaultValue="Currency"
                />
              </Box>
            </Box>
          );
        }
        return null;

      case "file":
        return (
          <FileField
            title={el.title}
            name={el.fieldName}
            fileUrls={uploadedFiles}
            progress={uploadProgress[el.fieldName] || []}
            setUploadedFiles={setUploadedFiles}
            setUploadProgress={setUploadProgress}
            setErrors={setErrors}
          />
        );

      case "multiline":
        return (
          <Multiline
            title={el.title}
            handleChange={handleChange}
            placeholder={el.placeholder}
            value={value}
            fieldName={el.fieldName}
          />
        );

      case "text":
      default:
        return (
          <InputField
            title={el.title}
            handleChange={handleChange}
            placeholder={el.placeholder}
            value={value}
            errors={errors[el.fieldName]}
            fieldName={el.fieldName}
          />
        );
    }
  };

  // Determine the title
  let drawerTitle = "Add Production Entry";
  if (isEditMode) {
    drawerTitle = "Edit Entry";
  } else if (user?.companyAdmin) {
    if (activeTab === 0) drawerTitle = "Add Production Entry";
    if (activeTab === 1) drawerTitle = "Add Revenue Entry";
  }

  return (
    <Drawer
      sx={{
        backgroundColor: "transparent",
        "& .MuiDrawer-paper": {
          backgroundColor: "transparent",
          boxShadow: "none",
          overflowY: "auto",
        },
      }}
      anchor="right"
      open={isDrawerOpen}
      // onClose={handleClose}
      onClose={handleCloseRequest}
    >
      <Box display="flex" gap={3} sx={{ width: "450px" }}>
        <Box
          sx={{
            backgroundColor: "#fff",
            height: "20px",
            padding: "13px",
            margin: "30px 0 0 0",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "80%",
            width: "5%",
          }}
        >
          <IconButton onClick={handleCloseRequest} sx={{ color: "black" }}>
            <CloseIcon sx={{ fontSize: "1.2rem" }} />
          </IconButton>
        </Box>
        <Box
          sx={{
            width: "100%",
            p: 3,
            backgroundColor: "#fff",
            minHeight: "100vh",
          }}
        >
          <Typography
            variant="h6"
            sx={{ textDecoration: "underline", fontWeight: "bold", mb: 2 }}
          >
            {drawerTitle}
          </Typography>

          {inputData.map((el) => (
            <div key={el.fieldName}>{renderInputField(el)}</div>
          ))}

          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 4 }}>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#0a3f73",
                textTransform: "none",
              }}
              onClick={Save}
            >
              {isEditMode ? "Submit" : "Submit"}
            </Button>

          </Box>
        </Box>
      </Box>
      <EditDialog
        editDialog={editDialog}
        setEditDialog={setEditDialog}
        handleExitAgree={handleExitAgree}
      />
    </Drawer>
  );
}

export default AddData;
